'use strict';
/*
* @package krobot
* @deps jquery
*/

const $ = jQuery;

$( '.js-toggle-trigger a' ).on( 'click keypress', function() {
	const toggleTarget = $( this ).attr( 'href' );
	$( toggleTarget ).slideToggle( 400 );
	$( this ).toggleClass( 'opened' );
	return false;
} );
